import { Routes, Route } from 'react-router-dom';
import { Home } from '../pages/Home';
import { Fixtures } from '../pages/Fixtures';
import { Groups } from '../pages/Groups';
import { Bracket } from '../pages/Bracket';
import { Teams } from '../pages/Teams';
import { TeamDetail } from '../pages/TeamDetail';
import { MatchDetail } from '../pages/MatchDetail';
import { Venues } from '../pages/Venues';
import { Scorers } from '../pages/Scorers';
import { Stats } from '../pages/Stats';
import { Resumen } from '../pages/Resumen';
import { Acceso } from '../pages/Acceso';
import { Uso } from '../pages/Uso';
import { Historico } from '../pages/Historico';
import { HistoricoYear } from '../pages/HistoricoYear';
import { Preferencias } from '../pages/Preferencias';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/fixtures" element={<Fixtures />} />
      <Route path="/groups" element={<Groups />} />
      <Route path="/bracket" element={<Bracket />} />
      <Route path="/teams" element={<Teams />} />
      <Route path="/venues" element={<Venues />} />
      <Route path="/scorers" element={<Scorers />} />
      <Route path="/stats" element={<Stats />} />
      <Route path="/resumen" element={<Resumen />} />
      <Route path="/acceso" element={<Acceso />} />
      <Route path="/uso" element={<Uso />} />
      <Route path="/historico" element={<Historico />} />
      <Route path="/historico/:year" element={<HistoricoYear />} />
      <Route path="/preferencias" element={<Preferencias />} />
      <Route path="/team/:name" element={<TeamDetail />} />
      <Route path="/match/:id" element={<MatchDetail />} />
    </Routes>
  );
}
